// // src/pages/HMS.js
// import React, { useEffect, useRef, useState } from 'react';
// import { Link } from 'react-router-dom';
// import { Helmet } from 'react-helmet';
// import Navbar from '../components/Navbar';
// import Footer from '../components/Footer';
// import imagesLoaded from 'imagesloaded';
// import './OneStepMedi.css';

// const API_URL = 'https://api.securxperts.com:8000';
// const ENDPOINT = '/forms/hms';

// /* -------------------- CONTACT FORM ----------------------- */
// const ContactForm = () => {
//   const [form, setForm] = useState({
//     name: '',
//     email: '',
//     country_code: '',
//     phoneno: '',
//     purpose: '',
//     branch_type: '',
//     type_of: '',
//     services: '',
//     no_of_beds: '',
//     total_logins: '',
//     product_taking_time: '',
//     heard_from: '',
//   });

//   const [submitting, setSubmitting] = useState(false);
//   const [status, setStatus] = useState(null);

//   const handleChange = (e) =>
//     setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));

//   const validate = () => {
//     if (!form.name.trim()) return 'Name is required';
//     if (!form.email.trim()) return 'Email is required';
//     const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     if (!emailRe.test(form.email)) return 'Enter a valid email';
//     if (!form.country_code.trim()) return 'Country code is required';
//     if (!form.phoneno.trim()) return 'Phone number is required';
//     if (!form.purpose.trim()) return 'Purpose is required';
//     if (!form.branch_type.trim()) return 'Branch type is required';
//     if (!form.type_of.trim()) return 'Type of hospital is required';
//     if (!form.services.trim()) return 'Services field is required';
//     if (!form.no_of_beds.trim()) return 'Number of beds is required';
//     if (!form.total_logins.trim()) return 'Total logins is required';
//     if (!form.product_taking_time.trim())
//       return 'Please tell us when you want to start using HMS';
//     if (!form.heard_from.trim()) return 'Please tell us how you heard about us';
//     return null;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setStatus(null);

//     const err = validate();
//     if (err) {
//       setStatus({ type: 'error', msg: err });
//       return;
//     }

//     setSubmitting(true);
//     try {
//       const payload = { ...form };

//       const resp = await fetch(`${API_URL}${ENDPOINT}`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(payload),
//       });

//       if (resp.ok) {
//         let data = null;
//         try {
//           data = await resp.json();
//         } catch {
//           // ignore parse errors
//         }
//         setStatus({
//           type: 'success',
//           msg: data?.message || 'Thank you! Your request has been submitted.',
//         });
//         setForm({
//           name: '',
//           email: '',
//           country_code: '',
//           phoneno: '',
//           purpose: '',
//           branch_type: '',
//           type_of: '',
//           services: '',
//           no_of_beds: '',
//           total_logins: '',
//           product_taking_time: '',
//           heard_from: '',
//         });
//       } else {
//         let errText = `Server responded with ${resp.status}`;
//         try {
//           const json = await resp.json();
//           if (json?.error) errText = json.error;
//           else if (json?.message) errText = json.message;
//         } catch {
//           const txt = await resp.text().catch(() => null);
//           if (txt) errText = txt;
//         }
//         setStatus({ type: 'error', msg: `Submission failed: ${errText}` });
//       }
//     } catch (error) {
//       console.error('HMS submit error:', error);
//       setStatus({ type: 'error', msg: 'Network error. Please try again.' });
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   return (
//     <form
//       onSubmit={handleSubmit}
//       className="max-w-3xl mx-auto bg-white/5 p-6 md:p-10 rounded-2xl shadow-lg"
//       aria-label="HMS Enquiry Form"
//     >
//       <h3 className="text-2xl md:text-3xl font-bold text-center mb-6 text-white">
//         Hospital Management System – Enquiry Form
//       </h3>

//       <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//         <input
//           name="name"
//           value={form.name}
//           onChange={handleChange}
//           placeholder="Full Name"
//           required
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
//         />

//         <input
//           name="email"
//           type="email"
//           value={form.email}
//           onChange={handleChange}
//           placeholder="Email"
//           required
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
//         />

//         <input
//           name="country_code"
//           value={form.country_code}
//           onChange={handleChange}
//           placeholder="Country Code (e.g. +91)"
//           required
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
//         />

//         <input
//           name="phoneno"
//           value={form.phoneno}
//           onChange={handleChange}
//           placeholder="Phone Number"
//           type="tel"
//           required
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
//         />

//         <input
//           name="purpose"
//           value={form.purpose}
//           onChange={handleChange}
//           placeholder="Purpose (Demo / Purchase / Upgrade)"
//           required
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none md:col-span-2"
//         />

//         <input
//           name="branch_type"
//           value={form.branch_type}
//           onChange={handleChange}
//           placeholder="Branch Type (Single / Multi-branch / Chain)"
//           required
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none md:col-span-2"
//         />

//         <input
//           name="type_of"
//           value={form.type_of}
//           onChange={handleChange}
//           placeholder="Type of Hospital (General / Specialty / Day-care, etc.)"
//           required
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none md:col-span-2"
//         />

//         <input
//           name="services"
//           value={form.services}
//           onChange={handleChange}
//           placeholder="Key Services (IPD/OPD, Labs, Radiology, Pharmacy, etc.)"
//           required
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none md:col-span-2"
//         />

//         <input
//           name="no_of_beds"
//           value={form.no_of_beds}
//           onChange={handleChange}
//           placeholder="No. of Beds"
//           required
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
//         />

//         <input
//           name="total_logins"
//           value={form.total_logins}
//           onChange={handleChange}
//           placeholder="Total Logins (Doctors, Nurses, Admin, etc.)"
//           required
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
//         />

//         <input
//           name="product_taking_time"
//           value={form.product_taking_time}
//           onChange={handleChange}
//           placeholder="When do you plan to start using HMS?"
//           required
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none md:col-span-2"
//         />

//         <input
//           name="heard_from"
//           value={form.heard_from}
//           onChange={handleChange}
//           placeholder="How did you hear about SecurXpert?"
//           required
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none md:col-span-2"
//         />
//       </div>

//       <button
//         type="submit"
//         disabled={submitting}
//         className="bg-blue-600 hover:bg-blue-700 transition px-6 py-3 rounded-full font-semibold w-full mt-6 disabled:opacity-50"
//       >
//         {submitting ? 'Submitting...' : 'Submit'}
//       </button>

//       {status && (
//         <p
//           role="status"
//           className={`text-center mt-4 text-sm ${
//             status.type === 'success' ? 'text-green-400' : 'text-red-400'
//           }`}
//         >
//           {status.msg}
//         </p>
//       )}

//       <p className="text-xs mt-4 text-white/60 text-center">
//         Your details will remain confidential and used only for enquiry purposes.
//       </p>
//     </form>
//   );
// };

// /* -------------------- MAIN PAGE ----------------------- */
// const HMS = () => {
//   const [isLoading, setIsLoading] = useState(true);
//   const [showScroll, setShowScroll] = useState(false);
//   const [scrollProgress, setScrollProgress] = useState(0);

//   // 🔁 Ref for hero video
//   const heroVideoRef = useRef(null);

//   // Image load -> hide loading screen
//   useEffect(() => {
//     imagesLoaded(
//       document.querySelectorAll('.content__item-img'),
//       { background: true },
//       () => {
//         document.body.classList.remove('loading');
//         setIsLoading(false);
//       }
//     );
//   }, []);

//   // Parallax scroll for cards
//   useEffect(() => {
//     const items = document.querySelectorAll('.content__item');

//     const handleScroll = () => {
//       items.forEach((item) => {
//         const img = item.querySelector('.content__item-img');
//         const wrapper = img?.parentNode;
//         if (!img || !wrapper) return;

//         const rect = item.getBoundingClientRect();
//         const progress = Math.min(
//           Math.max((window.innerHeight - rect.top) / (window.innerHeight + rect.height), 0),
//           1
//         );

//         const translateY = progress * 100 - 50;
//         const rotate = progress * -45;

//         img.style.transform = `translateY(${translateY}px)`;
//         wrapper.style.transform = `rotate3d(1, 0.3, 0.1, ${rotate}deg)`;
//       });
//     };

//     window.addEventListener('scroll', handleScroll);
//     handleScroll();

//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   // Circular scroll progress button visibility & progress
//   useEffect(() => {
//     const circumference = 307.919;
//     const handleProgress = () => {
//       const scrollTop = window.scrollY || document.documentElement.scrollTop;
//       const docHeight = document.documentElement.scrollHeight - window.innerHeight;
//       const progress = docHeight > 0 ? Math.min(Math.max(scrollTop / docHeight, 0), 1) : 0;
//       setScrollProgress(circumference * progress);
//       setShowScroll(scrollTop > 600);
//     };

//     window.addEventListener('scroll', handleProgress);
//     handleProgress();
//     return () => window.removeEventListener('scroll', handleProgress);
//   }, []);

//   // 🔁 Restart hero video when user scrolls back to top
//   useEffect(() => {
//     let wasNotAtTop = false;

//     const handleVideoReset = () => {
//       const scrollTop = window.scrollY || document.documentElement.scrollTop;
//       const isAtTop = scrollTop < 50;

//       // Only reset when transitioning from not-top → top
//       if (isAtTop && wasNotAtTop && heroVideoRef.current) {
//         heroVideoRef.current.currentTime = 0;
//         heroVideoRef.current.play().catch(() => {});
//       }

//       wasNotAtTop = !isAtTop;
//     };

//     window.addEventListener('scroll', handleVideoReset);
//     handleVideoReset(); // initial check

//     return () => window.removeEventListener('scroll', handleVideoReset);
//   }, []);

//   const scrollToTop = () => {
//     window.scrollTo({ top: 0, behavior: 'smooth' });

//     // also restart video when using the scroll-to-top button
//     if (heroVideoRef.current) {
//       heroVideoRef.current.currentTime = 0;
//       heroVideoRef.current.play().catch(() => {});
//     }
//   };

//   return (
//     <>
//       <Helmet>
//         <title>Hospital Management System | Secure, Modern Healthcare Platform</title>
//         <meta
//           name="description"
//           content="Streamline hospital operations with SecurXpert's HMS: AI scheduling, intuitive dashboards, advanced security, and seamless integration for superior patient care."
//         />
//       </Helmet>

//       {/* Loading Screen */}
//       <div
//         className={`fixed inset-0 bg-black flex items-center justify-center z-50 transition-opacity duration-1000 ${
//           isLoading ? 'opacity-100' : 'opacity-0 pointer-events-none'
//         }`}
//       >
//         <h1 className="text-5xl md:text-7xl font-bold text-white animate-pulse text-center px-4">
//           SecurXpert Hospital Management System
//         </h1>
//       </div>

//       {/* Navbar */}
//       <Navbar />

//       {/* Hero Video Section */}
//       <section className="relative h-screen">
//         <video
//           ref={heroVideoRef}
//           className="absolute inset-0 w-full h-full object-cover"
//           autoPlay
//           loop
//           muted
//           playsInline
//         >
//           <source src="/video/Arogya Narayan.mp4" type="video/mp4" />
//         </video>
//         <div className="absolute inset-0 bg-black/60" />
//       </section>

//       {/* Main Content with Parallax */}
//       <main className="bg-black text-white">
//         <div className="content content--padded">
//           {/* Core Features Section */}
//           <section className="py-12 max-w-5xl mx-auto text-left px-6">
//             <h2 className="text-3xl md:text-4xl font-extrabold mb-6">
//               Core Features of SecurXpert Hospital Management System
//             </h2>

//             {/* Customized User Experiences */}
//             <div className="mb-8">
//               <h3 className="text-2xl md:text-3xl font-bold mb-3">Customized User Experiences</h3>
//               <p className="mb-2 text-base md:text-lg">
//                 <strong>Intuitive Dashboards:</strong> We provide role-specific interfaces—for physicians,
//                 nursing staff, lab technicians, administrators, and finance teams—ensuring relevant data is
//                 always a click away, optimizing daily tasks.
//               </p>
//               <p className="text-base md:text-lg">
//                 <strong>Flexible Workflow Customization:</strong> Adapt the system to your hospital’s specific
//                 needs. Customize forms, approval hierarchies, and process flows to mirror your unique operational
//                 structure.
//               </p>
//             </div>

//             {/* Operational Efficiency & AI */}
//             <div className="mb-8">
//               <h3 className="text-2xl md:text-3xl font-bold mb-3">Operational Efficiency &amp; AI</h3>
//               <p className="mb-2 text-base md:text-lg">
//                 <strong>AI-Powered Scheduling:</strong> Our smart algorithms optimize bed allocation and
//                 operating theater (OT) scheduling, minimizing idle time and enhancing patient flow throughout the
//                 facility.
//               </p>
//               <p className="text-base md:text-lg">
//                 <strong>Offline Operational Assurance:</strong> Maintain seamless functionality even during
//                 network outages. Data automatically syncs once connectivity is restored, guaranteeing
//                 uninterrupted operations.
//               </p>
//             </div>

//             {/* Advanced Usability & Integration */}
//             <div className="mb-8">
//               <h3 className="text-2xl md:text-3xl font-bold mb-3">
//                 Advanced Usability &amp; Integration
//               </h3>
//               <p className="mb-2 text-base md:text-lg">
//                 <strong>Voice-Enabled Documentation:</strong> Utilize hands-free commands for efficient clinical
//                 note-taking and order entry, enhancing safety and allowing clinicians to focus on patient
//                 interaction.
//               </p>
//               <p className="text-base md:text-lg">
//                 <strong>Seamless Interoperability:</strong> Connect effortlessly with existing systems including
//                 EHR (Electronic Health Records), PACS/RIS/LIS, payment gateways, and essential government health
//                 portals via secure FHIR protocols.
//               </p>
//             </div>

//             {/* Communication & Compliance */}
//             <div className="mb-8">
//               <h3 className="text-2xl md:text-3xl font-bold mb-3">
//                 Communication &amp; Compliance
//               </h3>
//               <p className="mb-2 text-base md:text-lg">
//                 <strong>Integrated Patient Engagement:</strong> Keep patients informed with automated reminders,
//                 report sharing, and timely updates delivered directly via WhatsApp or SMS.
//               </p>
//               <p className="text-base md:text-lg">
//                 <strong>Instant Regulatory Reporting:</strong> Generate NABH, NABL, and all required statutory
//                 compliance reports instantly in pre-approved formats, simplifying audits.
//               </p>
//             </div>

//             {/* Reliable Support */}
//             <div className="mb-2">
//               <h3 className="text-2xl md:text-3xl font-bold mb-3">Reliable Support</h3>
//               <p className="text-base md:text-lg">
//                 <strong>Dedicated 24/7 Support:</strong> Our team of specialized healthcare IT professionals is
//                 available around the clock to provide expert assistance, training, and guidance whenever you need
//                 it.
//               </p>
//             </div>
//           </section>

//           {/* Parallax Cards – HMS visuals */}
//           <div
//             className="content__item content__item--expand"
//             style={{ ['--aspect-ratio']: '7/5' }}
//           >
//             <div className="content__item-imgwrap">
//               <div
//                 className="content__item-img"
//                 style={{ backgroundImage: "url('/img/hms-dashboard.jpg')" }}
//               />
//             </div>
//             <h2 className="content__item-title">Role-Based Hospital Dashboards</h2>
//             <p className="content__item-description">
//               Clinical, administrative and finance teams get tailored dashboards, surfacing the exact KPIs and
//               actions they need every day.
//             </p>
//           </div>

//           <div
//             className="content__item content__item--expand"
//             style={{ ['--aspect-ratio']: '7/5' }}
//           >
//             <div className="content__item-imgwrap">
//               <div
//                 className="content__item-img"
//                 style={{ backgroundImage: "url('/img/hms-aischeduling.jpg')" }}
//               />
//             </div>
//             <h2 className="content__item-title">AI-Optimised Bed &amp; OT Scheduling</h2>
//             <p className="content__item-description">
//               Reduce bottlenecks and idle time with predictive scheduling of beds and operating theatres powered
//               by AI.
//             </p>
//           </div>

//           <div
//             className="content__item content__item--expand"
//             style={{ ['--aspect-ratio']: '7/5' }}
//           >
//             <div className="content__item-imgwrap">
//               <div
//                 className="content__item-img"
//                 style={{ backgroundImage: "url('/img/hms-integration.jpg')" }}
//               />
//             </div>
//             <h2 className="content__item-title">Secure Healthcare Integrations</h2>
//             <p className="content__item-description">
//               Connect with EHR, LIS, RIS, PACS, payment gateways and government health portals using proven FHIR
//               APIs and secure protocols.
//             </p>
//           </div>

//           <div
//             className="content__item content__item--expand"
//             style={{ ['--aspect-ratio']: '7/5' }}
//           >
//             <div className="content__item-imgwrap">
//               <div
//                 className="content__item-img"
//                 style={{ backgroundImage: "url('/img/hms-communication.jpg')" }}
//               />
//             </div>
//             <h2 className="content__item-title">Patient Communication &amp; Compliance</h2>
//             <p className="content__item-description">
//               Engage patients via WhatsApp/SMS and generate NABH/NABL-ready reports in a few clicks for smooth
//               audits.
//             </p>
//           </div>

//           {/* CTA */}
//           <section className="text-center py-32">
//             <h2 className="text-4xl md:text-7xl font-bold mb-10">
//               Ready to Transform Your Hospital Operations?
//             </h2>
//             <div className="space-x-8">
//               <Link
//                 to="/get-quoted"
//                 className="inline-block bg-blue-600 text-white px-10 py-5 rounded-full text-2xl font-bold hover:bg-blue-700 transition transform hover:scale-110"
//               >
//                 Book HMS Demo
//               </Link>
//               <Link
//                 to="/contact-us"
//                 className="inline-block bg-white text-blue-600 px-10 py-5 rounded-full text-2xl font-bold hover:bg-gray-100 transition transform hover:scale-110"
//               >
//                 Talk to Our Team
//               </Link>
//             </div>
//           </section>

//           {/* Contact section */}
//           <section id="contact" className="py-16 bg-gradient-to-b from-black to-gray-900">
//             <div className="max-w-6xl mx-auto px-6">
//               <h3 className="text-3xl md:text-4xl font-extrabold text-center mb-6">
//                 Get in touch
//               </h3>
//               <p className="text-center text-white/70 mb-8">
//                 Have a question, need pricing, or want a customised HMS demo for your hospital? Share your
//                 details and our team will connect with you.
//               </p>

//               <ContactForm />
//             </div>
//           </section>
//         </div>
//       </main>

//       {/* Footer */}
//       <Footer />

//       {/* Scroll to Top Button (arrow) */}
//       <button
//         onClick={scrollToTop}
//         className="scrollToTopBtn fixed bottom-10 right-10 z-50 opacity-0 transition-all duration-700"
//       >
//         <svg className="w-16 h-16 text-white drop-shadow-2xl" viewBox="0 0 512 512">
//           <path fill="currentColor" d="M256 108L109 296l37 37 90-90v210h48V243l90 90 37-37z" />
//         </svg>
//       </button>

//       {/* Circular Scroll Progress Button */}
//       {showScroll && (
//         <div
//           onClick={scrollToTop}
//           className="scroll-top fixed bottom-6 right-6 z-50 cursor-pointer flex items-center justify-center w-14 h-14 rounded-full bg-gradient-to-r from-blue-500 to-blue-700 shadow-lg hover:from-blue-600 hover:to-blue-800 transition-all"
//         >
//           <svg className="progress-circle -rotate-90 w-12 h-12 absolute" viewBox="-1 -1 102 102">
//             <path
//               d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
//               fill="none"
//               stroke="white"
//               strokeWidth="4"
//               strokeDasharray="307.919"
//               strokeDashoffset={307.919 - scrollProgress}
//               style={{ transition: 'stroke-dashoffset 0.1s linear' }}
//             />
//           </svg>
//           <svg
//             xmlns="http://www.w3.org/2000/svg"
//             className="w-6 h-6 text-white relative z-10"
//             fill="none"
//             viewBox="0 0 24 24"
//             stroke="currentColor"
//             strokeWidth={2}
//           >
//             <path strokeLinecap="round" strokeLinejoin="round" d="M5 15l7-7 7 7" />
//           </svg>
//         </div>
//       )}
//     </>
//   );
// };

// export default HMS;










import React, { useState } from "react";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
 
export default function Hms() {
 /* ================= FORM LOGIC ADDED ================= */
const initialForm = {
  name: "",
  email: "",
  country_code: "+91",
  phoneno: "",
  purpose: "",
  branch_type: "",
  type_of: "",
  services: "",
  no_of_beds: "",
  total_logins: "",
  product_taking_time: "",
  heard_from: "",
  message: ""
};

const [formData, setFormData] = useState(initialForm);
const [formMessage, setFormMessage] = useState("");
const [formError, setFormError] = useState(""); // <- required by JSX alert
const [isSubmitting, setIsSubmitting] = useState(false);

const handleInputChange = (e) => {
  // support both id and name attributes
  const key = e.target.id || e.target.name;
  const value = e.target.value;
  setFormData((prev) => ({ ...prev, [key]: value }));

  if (key === "country_code") {
    const phoneField = document.getElementById("phoneno");
    if (phoneField) {
      phoneField.placeholder = `Your Phone Number (${value})`;
    }
  }
};

const parseFastAPIError = (errorData) => {
  if (!errorData) return "Unknown error";

  if (errorData.detail) {
    if (Array.isArray(errorData.detail)) {
      return errorData.detail
        .map((err) => {
          const field = Array.isArray(err.loc) ? err.loc.slice(1).join(".") : "";
          const msg = err.msg || err;
          return field ? `${field}: ${msg}` : msg;
        })
        .join(", ");
    } else if (typeof errorData.detail === "string") {
      return errorData.detail;
    }
  }

  if (errorData.message) return errorData.message;
  if (errorData.error) return errorData.error;
  if (typeof errorData === "string") return errorData;

  return JSON.stringify(errorData);
};

const handleSubmit = async (e) => {
  e.preventDefault();

  // clear previous messages
  setFormMessage("");
  setFormError("");
  setIsSubmitting(true);

  try {
    // send full payload expected by backend
    const payload = {
      name: formData.name,
      email: formData.email,
      country_code: formData.country_code,
      phoneno: formData.phoneno,
      purpose: formData.purpose,
      branch_type: formData.branch_type,
      type_of: formData.type_of,
      services: formData.services,
      no_of_beds: formData.no_of_beds,
      total_logins: formData.total_logins,
      product_taking_time: formData.product_taking_time,
      heard_from: formData.heard_from,
      message: formData.message
    };

    const response = await fetch("https://api.securxperts.com:8000/forms/hms", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    let result = null;
    try {
      result = await response.json();
    } catch {
      // if response is non-json, capture text for debugging
      const txt = await response.text().catch(() => null);
      if (!response.ok) throw new Error(`Server returned: ${txt || response.statusText}`);
    }

    if (response.ok) {
      setFormMessage("✅ Message sent successfully!");
      setFormError("");
      setFormData(initialForm);
    } else {
      const errorMsg = parseFastAPIError(result);
      setFormError(`❌ ${errorMsg}`);
      setFormMessage("");
    }
  } catch (err) {
    console.error("HMS submit error:", err);
    setFormError(`❌ ${err.message || "Failed to send message"}`);
    setFormMessage("");
  } finally {
    setIsSubmitting(false);
  }
};
/* ================= END FORM LOGIC ================= */

 
  return (
    <div className="w-full overflow-hidden font-sans text-[#063852]">
      <Navbar />
 
      {/* ================= HERO SECTION ================= */}
      <section className="relative w-full bg-white py-2 px-6 md:px-16">
        <div className="absolute top-0 right-0 w-[420px] h-[420px] bg-[#cae9ff] rounded-bl-full opacity-70 -z-10"></div>
 
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
          {/* Left Text */}
          <div>
           <img
  src="/img/aroganarayan.png"
  alt="Logo"
  className="w-32 h-55 mb-6 object-contain"
/>

            <p className="text-sm tracking-wide font-semibold text-[#2c75ff] mb-2">
              ALL-IN-ONE HEALTHCARE PLATFORM
            </p>
 
            <h1 className="text-3xl md:text-4xl font-bold leading-tight">
              Best Hospital Management System for Healthcare
            </h1>
 
            <p className="text-gray-600 mt-4 leading-relaxed">
              An advanced, AI-enabled Hospital Management System built to accelerate complete digital transformation. Streamline clinical workflows, elevate patient care and optimize operations with secure, cloud-based automation. It enhances staff productivity with automated scheduling and digital records, improves decision making through AI-powered insights and real-time alerts and ensures safe, seamless operations with encrypted data and full compliance.

            </p>
 
            {/* <div className="flex gap-4 mt-6">
              <button className="px-6 py-3 bg-[#2c75ff] text-white rounded-lg font-semibold hover:bg-[#1d5bd9] transition">
                Book a Demo
              </button>
              <button className="px-6 py-3 border border-[#2c75ff] text-[#2c75ff] rounded-lg font-semibold hover:bg-[#2c75ff] hover:text-white transition">
                Contact Us
              </button>
            </div> */}
          </div>
 
          {/* Right Image */}
          <div>
            <img
              src="/img/hmshero.png"
              alt="Hospital Dashboard"
              className="w-full drop-shadow-lg"
            />
          </div>
        </div>
      </section>
 
      {/* ================= VIDEO SECTION ================= */}
      <section className="w-full py-20 px-6 md:px-0 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <div className="max-w-3xl mx-auto mb-10 text-center">
            <h2 className="text-3xl font-bold text-[#063852]">
              Watch Arogya Narayan HMS in Action
            </h2>
            <p className="text-gray-600 mt-3">
              See how Arogya Narayan HMS makes hospital management simple and efficient. Automate
              workflows, improve patient care and keep everything running smoothly with our
              AI-powered platform.
            </p>
          </div>
 
          <div className="relative rounded-2xl md:rounded-3xl overflow-hidden shadow-2xl group">
            <video
              className="w-full block"
              src="/video/Arogya Narayan.mp4"
              muted
              playsInline
              autoPlay
              loop
              preload="auto"
              controls={false}
              key="lauratek-video"
              onClick={(e) => {
                const video = e.currentTarget;
                video.paused ? video.play() : video.pause();
              }}
            >
              Your browser does not support HTML5 video.
            </video>
 
            <div className="absolute bottom-6 right-6 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  const video = e.currentTarget.closest("div").querySelector("video");
                  if (video.requestFullscreen) video.requestFullscreen();
                }}
                className="bg-black/70 hover:bg-black/90 text-white p-4 rounded-xl backdrop-blur-md transition transform hover:scale-110 shadow-2xl"
                title="Fullscreen"
              >
                <svg
                  className="w-8 h-8"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5v-4m0 4h-4m4-4l-5-5"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </section>
 
      {/* ================= WHY CHOOSE US ================= */}
      <section className="w-full py-20 px-6 md:px-16 bg-[#f8fbff]">
        <h2 className="text-3xl text-center font-bold mb-4">
          Why Choose Our Arogya Narayan for Digital Transformation?
        </h2>
        <p className="text-center text-gray-600 mb-12">
          Transforming Healthcare, Smarter &amp; Faster
        </p>
 
        <div className="max-w-7xl mx-auto grid md:grid-cols-4 gap-10">
          <div className="bg-white p-6 shadow rounded-xl text-center">
            <h3 className="font-bold text-lg mb-2">1. End-to-End Digital Upgrade</h3>
            <p className="text-gray-600 text-sm">
              Upgrade your healthcare facility into a smart, automated and data-driven
              digital environment with next-gen Hospital Management solutions.
            </p>
          </div>
 
          <div className="bg-white p-6 shadow rounded-xl text-center">
            <h3 className="font-bold text-lg mb-2">2. Modern &amp; User-Focused Interface</h3>
            <p className="text-gray-600 text-sm">
              A smart, responsive HMS interface built to boost staff productivity,
              streamline daily operations and improve overall workflow efficiency.
            </p>
          </div>
 
          <div className="bg-white p-6 shadow rounded-xl text-center">
            <h3 className="font-bold text-lg mb-2">3. Mobile-Ready Hospital Operations</h3>
            <p className="text-gray-600 text-sm">
              Access EMRs, billing, appointments and patient updates anytime, anywhere—
              ensuring uninterrupted operations across devices.
            </p>
          </div>
 
          <div className="bg-white p-6 shadow rounded-xl text-center">
            <h3 className="font-bold text-lg mb-2">4. Digital Healthcare Architecture</h3>
            <p className="text-gray-600 text-sm">
              Built to grow with you from single clinics to multi-hospital networks with
              seamless scalability and modular expansion.
            </p>
          </div>
        </div>
      </section>
 
      {/* ================= DIGITAL TRANSFORMATION ================= */}
      <section className="w-full py-20 px-6 md:px-16 relative">
        <div className="absolute left-0 top-20 w-[280px] h-[280px] bg-[#d9efff] rounded-r-full opacity-40 -z-10"></div>
 
        <h2 className="text-3xl font-bold mb-4">Digital Transformation Capabilities</h2>
        <p className="text-gray-600 mb-4 max-w-2xl">
          Smart, End-to-End Hospital Digital Solutions
        </p>
 
        <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-10 items-center">
          <ul className="space-y-4 text-gray-700">
            <li>
              <span className="font-semibold">• Automated Operational Workflows</span>
              <br />
              Digitise administrative, clinical and financial processes with smart
              automation to cut manual work and gaps.
            </li>
            <li>
              <span className="font-semibold">• Complete Patient Pathway Management</span>
              <br />
              Manage the full patient journey Registration → Consultation → EMR →
              Diagnostics → Treatment → Billing → Discharge on one platform.
            </li>
            <li>
              <span className="font-semibold">• Integrated Hospital Operations Suite</span>
              <br />
              Comprehensive modules: Pharmacy, Lab, Radiology, Bed &amp; Ward, Inventory,
              HR, Finance and more.
            </li>
            <li>
              <span className="font-semibold">• Regulatory &amp; Compliance Built-In</span>
              <br />
              Ensure NABH, HIPAA and other healthcare compliance with integrated,
              audit-ready reporting.
            </li>
          </ul>
 
          <img
            src="/img/hms1.jpg"
            className="w-full drop-shadow-lg"
            alt="Digital Capability"
          />
        </div>
      </section>
 
      {/* ================= KEY FEATURES ================= */}
      <section className="w-full py-20 px-6 md:px-16 bg-[#f8fbff]">
        <h2 className="text-3xl font-bold text-center mb-4">
          Key Features of Our Digital Healthcare
        </h2>
        <p className="text-center text-gray-600 mb-12 max-w-3xl mx-auto">
          Next-gen intelligent, secure, and automated features to modernise workflows
          and enable a digital healthcare experience.
        </p>
 
        <div className="max-w-7xl mx-auto grid md:grid-cols-3 gap-8">
          {[
            {
              title: "1. Personalised User Dashboards",
              text: "Role-based access ensures doctors, nurses, lab teams and administrators view only the tools and information they need.",
            },
            {
              title: "2. Seamless Dashboards",
              text: "Visual dashboards and flexible forms, along with approvals and processes, are tailored to match your hospital’s operational structure.",
            },
            {
              title: "3. AI-Driven Scheduling & Planning",
              text: "AI intelligently optimises bed management, OT utilisation, and overall resource allocation, enhancing patient flow while reducing operational downtime effectively.",
            },
            {
              title: "4. Offline Operational Continuity",
              text: "Maintain uninterrupted hospital workflows even when the network is down, with auto-sync once connectivity returns.",
            },
            {
              title: "5. Seamless System Interoperability",
              text: "Effortless integration with EHR, PACS/RIS/LIS, payment systems, and national health portals, plus voice-enabled documentation for faster notes.",
            },
            {
              title: "6. Patient Engagement & Automation",
              text: "Automated WhatsApp and SMS notifications, instant NABH/NABL reporting and built-in compliance tools enhance patient communication and accreditation readiness.",
            },
          ].map((feature, i) => (
            <div
              key={i}
              className="
                group bg-white p-6 rounded-xl shadow
                border border-transparent
                relative overflow-hidden
                transition-all duration-300
                hover:shadow-xl hover:scale-[1.03]
              "
            >
              <span className="absolute top-0 left-0 w-0 h-[3px] bg-[#2c75ff] transition-all duration-300 group-hover:w-full"></span>
              <span className="absolute bottom-0 right-0 w-0 h-[3px] bg-[#2c75ff] transition-all duration-300 group-hover:w-full"></span>
 
              <h3 className="font-bold text-lg mb-2">{feature.title}</h3>
              <p className="text-gray-600 text-sm">{feature.text}</p>
            </div>
          ))}
        </div>
      </section>
 
      {/* ================= ADDED QUICK FORM SECTION ================= */}
      <section className="w-full py-20 px-6 md:px-16 bg-white">
  <h2 className="text-3xl font-bold text-center mb-10">Quick Contact Form</h2>

  <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-lg p-8">
    <form onSubmit={handleSubmit}>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">

        {/* Error Message (RED) */}
        {formError && (
          <p className="col-span-1 sm:col-span-2 bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded-lg">
            {formError}
          </p>
        )}

        {/* Name */}
        <input
          id="name"
          type="text"
          placeholder="Your Name"
          value={formData.name}
          onChange={handleInputChange}
          className="w-full border border-gray-300 rounded-lg px-4 py-3"
          required
        />

        {/* Email */}
        <input
          id="email"
          type="email"
          placeholder="Your Email"
          value={formData.email}
          onChange={handleInputChange}
          className="w-full border border-gray-300 rounded-lg px-4 py-3"
          required
        />

        {/* Country Code */}
        <select
          id="country_code"
          value={formData.country_code}
          onChange={handleInputChange}
          className="w-full border border-gray-300 rounded-lg px-4 py-3"
          required
        >
          <option value="+91">India (+91)</option>
          <option value="+1">USA (+1)</option>
          <option value="+1">Canada (+1)</option>
          <option value="+44">UK (+44)</option>
          <option value="+61">AUS (+61)</option>
        </select>

        {/* Phone */}
        <input
          id="phoneno"
          type="tel"
          placeholder="Your Phone Number"
          value={formData.phoneno}
          onChange={handleInputChange}
          className="w-full border border-gray-300 rounded-lg px-4 py-3"
          required
        />

        {/* Purpose */}
        <input
          id="purpose"
          type="text"
          placeholder="Purpose"
          value={formData.purpose}
          onChange={handleInputChange}
          className="w-full border border-gray-300 rounded-lg px-4 py-3"
          required
        />

        {/* Branch Type */}
        <input
          id="branch_type"
          type="text"
          placeholder="Branch Type"
          value={formData.branch_type}
          onChange={handleInputChange}
          className="w-full border border-gray-300 rounded-lg px-4 py-3"
          required
        />

        {/* Type Of */}
        <input
          id="type_of"
          type="text"
          placeholder="Type Of"
          value={formData.type_of}
          onChange={handleInputChange}
          className="w-full border border-gray-300 rounded-lg px-4 py-3"
          required
        />

        {/* Services */}
        <input
          id="services"
          type="text"
          placeholder="Services"
          value={formData.services}
          onChange={handleInputChange}
          className="w-full border border-gray-300 rounded-lg px-4 py-3"
          required
        />

        {/* No of Beds */}
        <input
          id="no_of_beds"
          type="text"
          placeholder="Number of Beds"
          value={formData.no_of_beds}
          onChange={handleInputChange}
          className="w-full border border-gray-300 rounded-lg px-4 py-3"
          required
        />

        {/* Total Logins */}
        <input
          id="total_logins"
          type="text"
          placeholder="Total Logins"
          value={formData.total_logins}
          onChange={handleInputChange}
          className="w-full border border-gray-300 rounded-lg px-4 py-3"
          required
        />

        {/* Product Taking Time */}
        <input
          id="product_taking_time"
          type="text"
          placeholder="Product Taking Time"
          value={formData.product_taking_time}
          onChange={handleInputChange}
          className="w-full border border-gray-300 rounded-lg px-4 py-3"
          required
        />

        {/* Heard From */}
        <input
          id="heard_from"
          type="text"
          placeholder="How Did You Hear About Us?"
          value={formData.heard_from}
          onChange={handleInputChange}
          className="w-full border border-gray-300 rounded-lg px-4 py-3"
          required
        />

        {/* Message */}
        <textarea
          id="message"
          placeholder="Message"
          value={formData.message}
          onChange={handleInputChange}
          rows="5"
          className="col-span-1 sm:col-span-2 border border-gray-300 rounded-lg px-4 py-3"
        ></textarea>

      </div>

      {/* Submit button */}
      <button
        type="submit"
        className="mt-6 w-full bg-[#2c75ff] text-white font-semibold py-3 rounded-lg hover:bg-[#1d5bd9] transition"
      >
        {isSubmitting ? "Sending..." : "Send Message"}
      </button>

      {/* Success message (GREEN) */}
      {formMessage && (
        <p className="text-center mt-4 text-lg font-medium bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded-lg">
          {formMessage}
        </p>
      )}
    </form>
  </div>
</section>


 
      <Footer />
    </div>
  );
}
 
 